import script from "./ProgramTechniquesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramTechniquesCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramTechniquesCard.vue?vue&type=style&index=0&id=df4e3664&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4e3664"]])

export default __exports__